import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'SharedSpinner',
  props: {
    darkSpinner: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	darkSpinner?: boolean;
}



const color = computed(() => (props.darkSpinner ? "#8C8C8E" : "#B7B7BA"));

return { __sfc: true,props, color }
}

})